<template>
    <div class="img-404" id="scene">
        <img src="../../assets/404/logo.png" class="logo"/>
        <img src="../../assets/404/feidie.png" class="layer feidie" data-depth="0.30"/>
        <img src="../../assets/404/img-404.png" class="img404"/>
        <a href="/">返回首页</a>
    </div>
</template>

<script>
    //  var scene = document.getElementById('scene');
    //  var parallax = new Parallax(scene);
    export default {
        name: 'Error404',
        data () {
        },
        mounted () {
        },
        methods: {}
    }
</script>
<style>
    * {
        padding: 0;
        margin: 0;
    }

    html,
    body {
        width: 100%;
        height: 100%;
    }

    body {
        position: relative;
    }

    .img-404 {
        width: 350px;
        height: 504px;
        position: absolute;
        z-index: 100;
        left: 50%;
        top: 50%;
        margin-left: -175px;
        margin-top: -252px;
    }

    .img-404 a {
        text-decoration: none;
        font-weight: 400;
        background: url('../../assets/404/home.png') left top no-repeat;
        background-size: 18px 18px;
        color: #666;
        font-size: 14px;
        position: absolute;
        bottom: -20px;
        display: inline-block;
        text-align: center;
        height: 18px;
        line-height: 20px;
        padding-left: 24px;
        left: 50%;
        margin-left: -40px;
    }

    .logo {
        width: 150px;
        margin: 0 auto;
        display: block;
    }

    .feidie {
        width: 203px;
        margin: 20px auto;
    }

    .img404 {
        width: 350px;
    }
</style>



// WEBPACK FOOTER //
// 404.vue?24f492bc